export enum OpenTokRole {
	MODERATOR = 'moderator',
	PUBLISHER = 'publisher',
	SUBSCRIBER = 'subscriber'
}
